<div class="flex flex-col h-full">
  <div class="p-6 flex flex-col gap-4">
    <app-text variant="muted" size="sm">
      {{ modalData.description || 'Upload a file and select its type below.' }}
    </app-text>

    @if (uploadError()) {
      <div class="p-4 rounded-md bg-surface border border-border text-red-500 text-sm">
        {{ uploadError() }}
      </div>
    }

    <form [formGroup]="form" class="space-y-4">
      <app-form-field label="Type *">
        <app-select
          formControlName="type"
          [options]="typeOptions"
          placeholder="Select type"
        ></app-select>
        @if (form.get('type')?.touched && form.get('type')?.invalid) {
          <app-text color="danger" size="xs" class="mt-1">Please select a type</app-text>
        }
      </app-form-field>

      <app-form-field label="File *">
        <app-file-upload
          formControlName="fileUrl"
          [uploadPath]="uploadPath"
          [accept]="accept"
          [allowedExtensions]="allowedExtensions"
          (uploadState)="onUploadState($event)"
        ></app-file-upload>
        @if (form.get('fileUrl')?.touched && form.get('fileUrl')?.invalid) {
          <app-text color="danger" size="xs" class="mt-1">Please upload a file</app-text>
        }
      </app-form-field>
    </form>
  </div>

  <div class="flex justify-end gap-3 p-4 border-t border-border bg-card mt-auto">
    <app-button variant="secondary" (click)="cancel()" [disabled]="isSaving() || isUploading()">
      Cancel
    </app-button>
    <app-button
      variant="primary"
      (click)="save()"
      [disabled]="form.invalid || isSaving() || isUploading()"
      [loading]="isSaving()"
    >
      {{ isSaving() ? 'Saving...' : 'Upload' }}
    </app-button>
  </div>
</div>
